/**
 * @author salla.sai shiva
 * @Date: 2022-11-04 16:20:30
 * @Last Modified by: salla.sai shiva
 * @Last Modified time: 2022-11-04 16:50:30
*/


const COLLAPSE_MCMD = Object.freeze({
  MCMD_DETAILS: [
    {
      mcmcId: 0,
      mcmdTitle: 'Material Contracts',
      subMcmd: [
        {
          subId: 0,
          subTitle: '1. Offer agreement dated December 19, 2022 read with amendment agreement dated August 30, 2023 entered into among our Company, the Selling Shareholders and the BRLMs.',
          dataSlug: [
            {
              id: 1,
              title: 'Amendment to Offer Agreement',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/offer-agreement/amendment-to-offer-agreement.pdf',
            },
            {
              id: 2,
              title: 'Offer Agreements dated December 19, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/offer-agreement/offer-agreements-19th-dec-2022.pdf',
            },
          ],
        },
        {
          subId: 1,
          subTitle: '2. Registrar agreement dated December 15, 2022 read with amendment agreement dated August 29, 2023 entered into among our Company, the Selling Shareholders and the Registrar to the Offer',
          dataSlug: [
            {
              id: 1,
              title: 'Letter of Indemnity to Amendment to Registrar Agreement',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/registrar-agreement/loi-amendment-to-registrar-agreement.pdf',
            },
            {
              id: 2,
              title: 'Amendment to Registrar Agreement dated August 29, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/registrar-agreement/amendment-to-registrar-agreement-29th-aug-2023.pdf',
            },
            {
              id: 3,
              title: 'Letter of Indemnity to Registrar Agreement',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/registrar-agreement/letter-of-indemnity-registrar-agreement-15th-dec-2022.pdf',
            },
            {
              id: 4,
              title: 'Registrar Agreement dated December 15, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/registrar-agreement/registrar-agreement-15th-dec-2022.pdf',
            },
          ],
        },
        {
          subId: 2,
          subTitle: '3. Monitoring agency agreement dated August 29, 2023 entered into between our Company and the Monitoring Agency.',
          dataSlug: [
            {
              id: 1,
              title: 'Monitoring Agency Agreement dated August 29, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/monitoring-agreement/monitoring-agency-agreement.pdf',
            },
          ],
        },
        {
          subId: 3,
          subTitle: '4. Cash escrow and sponsor bank agreement dated September 7, 2023 entered into among our Company, the Selling Shareholders, the BRLMs, Bankers to the Offer, and the Registrar to the Offer.',
          dataSlug: [
            {
              id: 1,
              title: 'Cash escrow and sponsor bank agreement dated September 7, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/cash-escrow-account/cash-escrow-agreement.pdf',
            },
          ],
        },
        {
          subId: 4,
          subTitle: '5. Share escrow agreement dated September 6, 2023 entered into among our Company, the Selling Shareholders, and the Share Escrow Agent.',
          dataSlug: [
            {
              id: 1,
              title: 'Letter of Indemnity to Share Escrow Agreement',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/share-escrow-agreement/letter-of-indemnity-share-escrow-agreements.pdf',
            },
            {
              id: 2,
              title: 'Share Escrow Agreement dated September 6, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/share-escrow-agreement/share-escrow-agreement.pdf',
            },
          ],
        },
        {
          subId: 5,
          subTitle: '6. Syndicate agreement dated September 7, 2023 entered into among our Company, the Selling Shareholders, the BRLMs and Syndicate Members.',
          dataSlug: [
            {
              id: 1,
              title: 'Syndicate agreement dated September 7, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-contract/syndicate-agreement/syndicate-agreement.pdf',
            },
          ],
        },
        {
          subId: 6,
          subTitle: '7. Underwriting agreement to be entered into among our Company, the Selling Shareholders, the BRLMs and Syndicate Members.',
          dataSlug: [],
        },
      ],
    },
    {
      mcmcId: 1,
      mcmdTitle: 'Material Documents',
      subMcmd: [
        {
          subId: 0,
          subTitle: '1. Certified copies of the Memorandum of Association and the Articles of Association, as amended until date.',
          dataSlug: [
            {
              id: 0,
              title: 'Memorandum of Association and the Articles of Association',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/moa-aoa/moa-and-aoa.pdf',
            },
          ],
        },
        {
          subId: 1,
          subTitle: '2. Certificate of incorporation dated June 2, 2011 issued by Registrar of Companies, Andhra Pradesh at Hyderabad.',
          dataSlug: [
            {
              id: 0,
              title: 'Certificate of Incorporation dated June 2, 2011',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/coi-one/certificate-of-incorporation-020611.pdf',
            },
          ],
        },
        {
          subId: 2,
          subTitle: '3. Fresh certificate of incorporation dated September 13, 2022 issued by the RoC, consequent to the change of name from ‘Zaggle Prepaid Ocean Services Private Limited’ to ‘Zaggle Prepaid Ocean Services Limited’, pursuant to conversion into a public limited company.',
          dataSlug: [
            {
              id: 0,
              title: 'Certificate of incorporation dated September 13, 2022, pursuant to conversion into public limited Company',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/coi-two/cert-of-incorp-consequent-upon-conversion.PDF',
            },
          ],
        },
        {
          subId: 3,
          subTitle: '4. Copies of the annual reports of the Company as of and for the Financial Years ended March 31, 2022, March 31, 2021 and March 31, 2020.',
          dataSlug: [
            {
              id: 0,
              title: 'Annual Report - 2020',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/annual-report/annual-report-2020.pdf',
            },
            {
              id: 1,
              title: 'Annual Report - 2021',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/annual-report/annual-report-2021.pdf',
            },
            {
              id: 2,
              title: 'Annual Report - 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2021-22.pdf',
            },
          ],
        },
        {
          subId: 4,
          subTitle: '5.  Resolution dated December 16, 2022 passed by the Board authorising the Offer and other related matters.',
          dataSlug: [
            {
              id: 0,
              title: 'Board resolution dated December 16, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/br-authorizing-the-offer/board-resolution.pdf',
            },
          ],
        },
        {
          subId: 5,
          subTitle: '6. Resolution dated December 16, 2022 passed by the Shareholders authorising the Fresh Issue and other related matters.',
          dataSlug: [
            {
              id: 0,
              title: 'Shareholders Resolution dated December 16, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/egm/egm-resolution.pdf',
            },
          ],
        },
        {
          subId: 6,
          subTitle: '7. Consent letters and authorisations/ resolutions passed by the respective boards of directors of the Selling Shareholders, as applicable, for participation in the Offer for Sale, as detailed in “The Offer” on page 68 of the Red Herring Prospectus',
          dataSlug: [
            {
              id: 0,
              title: 'Consent from Selling Shareholders',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-letter-and-br-for-ofs/consent-selling-shareholder-and-br-for-ofs.pdf',
            },
          ],
        },
        {
          subId: 7,
          subTitle: '8. Resolution dated December 19, 2022 passed by the Board, approving the Draft Red Herring Prospectus.',
          dataSlug: [
            {
              id: 0,
              title: 'Board Resolutions dated December 19, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/br-dt-19th-dec-approving-the-drhp/ctc-board-resolutions-dt-19th-december-2022.pdf',
            },
          ],
        },
        {
          subId: 8,
          subTitle: '9. Resolution dated September 8, 2023 passed by the Board, approving the Red Herring Prospectus and certain other related matters.',
          dataSlug: [
            {
              id: 0,
              title: 'Board Resolutions dated September 8, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/br-for-rhp-approval/ctc-br-08-09-2023-rhp.pdf',
            },
          ],
        },
        {
          subId: 9,
          subTitle: '10. Report titled “Industry Report on SaaS based Fintech Market in India” dated August 23, 2023, issued by Frost & Sullivan pursuant to an engagement letter dated February 9, 2022 and an addendum to such engagement letter dated August 19, 2023 entered into with our Company.',
          dataSlug: [
            {
              id: 0,
              title: 'Industry Report on SaaS based Fintech Market in India dated August 23, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/industry-report/industry-report.pdf',
            },
          ],
        },
        {
          subId: 10,
          subTitle: '11. Consent letter dated August 23, 2023 issued by Frost & Sullivan with respect to the report titled “Industry Report on SaaS based Fintech Market in India” dated August 23, 2023.',
          dataSlug: [
            {
              id: 0,
              title: 'Consent from Frost & Sullivan dated August 23, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-letter-f-s/consent-letter.pdf',
            },
          ],
        },
        {
          subId: 11,
          subTitle: '12. The examination report dated August 29, 2023 of the Joint Statutory Auditors with respect to the Restated Financial Information.',
          dataSlug: [
            {
              id: 0,
              title: 'Examination Report dated August 29, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/examination-report-dt-29th-aug-2023/examination-report.pdf',
            },
          ],
        },
        {
          subId: 12,
          subTitle: '13. The report dated August 30, 2023 of the Joint Statutory Auditors, on the statement of possible special tax benefits.',
          dataSlug: [
            {
              id: 0,
              title: 'Statement of Special Tax benefit dated August 30, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/joint-auditor-report-on-stb/statement-of-special-tax-benefit.pdf',
            },
            {
              id: 1,
              title: 'SOTB - Annexures',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/joint-auditor-report-on-stb/sotb-management-statement.pdf',
            },
          ],
        },
        {
          subId: 13,
          subTitle: '14. Consent dated August 30, 2023 from the Joint Statutory Auditors, P R S V & Co. LLP, Chartered Accountants and M S K A & Associates, Chartered Accountant, to include their name as required under Section 26(5) of the Companies Act read with the SEBI ICDR Regulations in the Red Herring Prospectus and as an “expert” as defined under Section 2(38) of the Companies Act to the extent and in their capacity as our Joint Statutory Auditors, and in respect of their (i) the examination report dated August 29, 2023 on the Restated Financial Information, and (ii) the report dated August 30, 2023 on the statement of possible special tax benefits, included in the Red Herring Prospectus.',
          dataSlug: [
            {
              id: 0,
              title: 'Consent from the Joint Statutory Auditors dated August 30, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-letter-from-both-to-include-names/consent-letter-joint-auditors.pdf',
            },
          ],
        },
        {
          subId: 14,
          subTitle: '15. Consent dated December 19, 2022 from P R S V & Co. LLP, Chartered Accountants, to include their name as required under Section 26(5) of the Companies Act read with the SEBI ICDR Regulations in the Red Herring Prospectus and as an “expert” as defined under Section 2(38) of Companies Act in respect of the certificates issued by them in their capacity as an independent chartered accountant to our Company.',
          dataSlug: [
            {
              id: 0,
              title: 'Consent Letter from P R S V & Co. LLP, Chartered Accountants dated December 19, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-letter-dt-19th-dec-prsv/consent-letter-prsv.pdf',
            },
          ],
        },
        {
          subId: 15,
          subTitle: '16. Consents of the BRLMs, the Registrar to the Offer, the banker to the Company, the Syndicate Members, Bankers to the Offer, Monitoring Agency, the legal counsel to the Company as to Indian law, our Directors and the Company Secretary and Compliance Officer, to act in their respective capacities.',
          dataSlug: [
            {
              id: 0,
              title: 'Consents from Banker to the offer',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/banker-consent.pdf',
            },
            {
              id: 1,
              title: 'Consent from the BRLM',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/brlm-consent.pdf',
            },
            {
              id: 2,
              title: 'Consent from Banker to Company',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/consent-banker-to-company.pdf',
            },
            {
              id: 3,
              title: 'Consent from Monitoring Agency',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/consent-letter-monitoring-agency.pdf',
            },
            {
              id: 4,
              title: 'Consent from Directors and Company Secretary',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/directors-and-cs-consent.pdf',
            },
            {
              id: 5,
              title: 'Consent from Registrar to the Offer',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/kfin-consent-letter.pdf',
            },
            {
              id: 6,
              title: 'Consent from Legal Counsel',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/legal-counsel-consent-letter.pdf',
            },
            {
              id: 7,
              title: 'Consent from Syndicate Member',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/consent-of-all-intermediary/syndicate-member-consent.pdf',
            },
          ],
        },
        {
          subId: 16,
          subTitle: '17. The ESOP Scheme.',
          dataSlug: [
            {
              id: 0,
              title: 'Amendment to ESOP Scheme',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/esop-scheme/amendment-to-esop-scheme.pdf',
            },
            {
              id: 1,
              title: 'ESOP Scheme',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/esop-scheme/original-esop-scheme.pdf',
            },
          ],
        },
        {
          subId: 17,
          subTitle: '18. Resolutions of the Board and Shareholders dated May 24, 2023 and June 23, 2023, respectively in relation to appointment of Raj P Narayanam as the Executive Chairman of our Company.',
          dataSlug: [
            {
              id: 0,
              title: 'Shareholders resolution dated June 23, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/raj-reappointment-resolution/egm-resolution.pdf',
            },
            {
              id: 0,
              title: 'Board Resolution dated May 24, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/raj-reappointment-resolution/re-appt-of-wtd.pdf',
            },
          ],
        },
        {
          subId: 18,
          subTitle: '19. Resolution of the Board dated April 30, 2021, in relation to appointment of Avinash Ramesh Godkhindi as the Managing Director and Chief Executive Officer of our Company.',
          dataSlug: [
            {
              id: 0,
              title: 'Board Resolution dated April 30, 2021',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/appointment-of-avinash/board-resolution-april-2021.pdf',
            },
          ],
        },
        {
          subId: 19,
          subTitle: '20. Employment agreement dated October 1, 2015, as amended by letter dated June 1, 2018 between our Company and Raj P Narayanam.',
          dataSlug: [
            {
              id: 0,
              title: 'Employment agreement dated October 1, 2015',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/employment-agreement-raj/employment-agreement-raj.pdf',
            },
            {
              id: 1,
              title: 'Aamendment to employement agreement by letter dated June 1, 2018',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/employment-agreement-raj/letter-dt-june-2018.pdf',
            },
          ],
        },
        {
          subId: 20,
          subTitle: '21. Employment agreement dated February 1, 2012, as amended by letter dated April 30, 2021 between our Company and Avinash Ramesh Godkhindi.',
          dataSlug: [
            {
              id: 0,
              title: 'Employment agreement dated February 1, 2012',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/employment-agreement-aviansh/employment-agreement-avinash.pdf',
            },
            {
              id: 1,
              title: 'Aamendment to employement agreement by letter dated April 30, 2021',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/employment-agreement-aviansh/letter-dt-30th-april-2021.pdf',
            },
          ],
        },
        {
          subId: 21,
          subTitle: '22. Scheme of amalgamation of Magixo with our Company approved by the Office of the Regional Director, South East Region, Hyderabad on March 1, 2022.',
          dataSlug: [
            {
              id: 0,
              title: 'Regional Director Order dated March 1, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/scheme-of-arrangement-and-order/rd-order.pdf',
            },
          ],
        },
        {
          subId: 22,
          subTitle: '23. Tripartite agreement dated April 8, 2022, among our Company, NSDL and the Registrar to the Offer.',
          dataSlug: [
            {
              id: 0,
              title: 'Tripartite Agreement dated April 8, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/tripartie-nsdl/tripartite-agreement-nsdl.pdf',
            },
          ],
        },
        {
          subId: 23,
          subTitle: '24. Tripartite agreement dated February 24, 2022, among our Company, CDSL and the Registrar to the Offer.',
          dataSlug: [
            {
              id: 0,
              title: 'Triparty Agreement dated February 24, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/tripartie-cdsl/triparty-agreement-cdsl-dsc-zaggle-prepaid-ocean.pdf',
            },
          ],
        },
        {
          subId: 24,
          subTitle: '25. Certificate from P R S V & Co. LLP, Chartered Accountants dated September 8, 2023 in relation to certain key performance indicators concerning our Company’s operational and financial performance.',
          dataSlug: [
            {
              id: 0,
              title: 'Certificate from P R S V & Co. LLP, Chartered Accountants dated September 8, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/kpi-certificate/certificate-basis-of-offer-price.pdf',
            },
          ],
        },
        {
          subId: 25,
          subTitle: '26. Due diligence certificate to SEBI from the BRLMs dated December 19, 2022.',
          dataSlug: [
            {
              id: 0,
              title: 'Due Diligence certificate dated December 19, 2022',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/due-diligence-certificate-brlm/due-diligence-report.pdf',
            },
          ],
        },
        {
          subId: 26,
          subTitle: '27. In-principle listing approvals dated January 24, 2023 and January 25, 2023 from BSE and NSE, respectively.',
          dataSlug: [
            {
              id: 0,
              title: 'BSE- In principle Approval dated January 24, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/in-principle-approval/bse-in-principle-approval.pdf',
            },
            {
              id: 1,
              title: 'NSE In principle Approval dated January 25, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/in-principle-approval/nse-in-principle-approval.pdf',
            },
          ],
        },
        {
          subId: 27,
          subTitle: '28. Final observations letter bearing number SEBI/HO/CFD/RAC-DIL2/P/OW/2023/12944/1 dated March 29, 2023 issued by SEBI.',
          dataSlug: [
            {
              id: 0,
              title: 'SEBI observations letter dated March 29, 2023',
              link: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/material-documents/final-obervation-letter/sebi-letter-29032023.pdf',
            },
          ],
        },
      ],
    },
  ],
});


export {
  COLLAPSE_MCMD,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/MCMD/constants.js